/**
 * DealsSpot -- empty-state spot illustration for the deals surface (#2580, Tier
 * 5, EPIC #2575). A property key motif (round bow + shaft + teeth) with a small
 * accent tag carrying a check -- reads as "a deal, done". Line-art on tokens,
 * ~160x120, aria-hidden. Agency-neutral.
 */
import SpotIllustration from "./SpotIllustration";

export function DealsSpot({ className }: { className?: string }) {
  return (
    <SpotIllustration className={className}>
      {/* Key bow */}
      <circle cx="56" cy="52" r="16" stroke="currentColor" strokeWidth="2.5" />
      <circle
        cx="56"
        cy="52"
        r="6"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.5"
      />
      {/* Key shaft */}
      <path d="M71 58 108 90" stroke="currentColor" strokeWidth="2.5" />
      {/* Key teeth */}
      <path
        d="M96 80l8-6M104 88l8-6"
        stroke="currentColor"
        strokeWidth="2.5"
      />
      {/* Accent tag with check */}
      <rect
        x="96"
        y="26"
        width="30"
        height="22"
        rx="5"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
      <path
        d="M104 37l4 4 8-9"
        stroke="var(--color-accent)"
        strokeWidth="2.5"
      />
    </SpotIllustration>
  );
}

export default DealsSpot;
